import sortBy from 'lodash/sortBy';
import values from 'lodash/values';

export default function toOrderedArray(obj) {
    let vals = values(obj);

    if(!vals.length) { return vals; }

    let prop = ('builder_order' in  vals[0]) ? 'builder_order' : 'order';

    return sortBy(values(obj), prop)
}